import React,{useState} from 'react';
import'./qualification.css';

const Qualification = () => {
    const[toggleState, setToggleState] = useState(1);
    const toggleTab = (index) =>{
        setToggleState(index);
    };
  return (
    <section className="qualification section">
        <h2 className="section__title">Qualification</h2>
        <span className="section__subtitle">My personal journey</span>

        <div className="qualification__container container">
            <div className="qualification__tabs">
                <div className= {toggleState === 1 ?  "qualification__button qualification__active button--flex" : "qualification__button   button--flex"} onClick={() => toggleTab(1)}>
                    <i className="uil uil-graduation-cap  qualification__icon"></i>
                    Education
                </div>

                <div className= {toggleState === 2 ?  "qualification__button qualification__active button--flex" : "qualification__button   button--flex"} onClick={() => toggleTab(2)}>
                    <i className="uil uil-briefcase-alt qualification__icon"></i>
                    Experience
                </div>
            </div>

            <div className="qualification__sections">
                <div className={toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}>
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">B C A</h3>
                            <span className="qualification__subtitle">V. k. s. u. university</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2017-21
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <div className="qualification__line"></div>
                        </div>
                    </div>

                    <div className="qualification__data">
                        <div>

                        </div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>

                        <div>
                            <h3 className="qualification__title">10+2 High school</h3>
                            <span className="qualification__subtitle">s.v.p. bhabua</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2015-2017
                            </div>
                        </div>

                    </div>

                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">High school</h3>
                            <span className="qualification__subtitle">A.B.S.H. bhabua</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2014-15
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <div className="qualification__line"></div>
                        </div>
                    </div>

                    {/* <div className="qualification__data">
                        <div>

                        </div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>

                        <div>
                            <h3 className="qualification__title">UX Expert</h3>
                            <span className="qualification__subtitle">Spain-Institute</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2021-2022
                            </div>
                        </div>

                    </div> */}
                </div>


                
                <div className={toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}>
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">Frontend developer</h3>
                            <span className="qualification__subtitle">Frelancer - India</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2021-Present
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <div className="qualification__line"></div>
                        </div>
                    </div>

                    <div className="qualification__data">
                        <div>

                        </div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>

                        <div>
                            <h3 className="qualification__title">Backend developer</h3>
                            <span className="qualification__subtitle">Frelancer - India</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2021-Present
                            </div>
                        </div>

                    </div>

                    <div className="qualification__data">
                        
                        <div>
                            <h3 className="qualification__title">Full stack</h3>
                            <span className="qualification__subtitle">Frelancer - India</span>
                            <div className="qualification__calender">
                                <i className="uil uil-calendar-alt"></i>
                                2022-Present
                            </div>
                        </div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <div className="qualification__line"></div>
                        </div>
                    </div>

                   

                   
                </div>
            </div>
        </div>
    </section>
   
  )
}

export default Qualification;
